import { BRAND } from "@/brand.config";
import { usePublicLoyalty } from "@/hooks/usePublicLoyalty";

export default function ReferralProgram() {
  const { config } = usePublicLoyalty();
  const referrer = Number(config?.referral_points_referrer || 0);
  const referee = Number(config?.referral_points_referee || 0);
  return (
    <div className="max-w-[1100px] mx-auto px-6 lg:px-12 py-20" data-testid="page-referral">
      <div className="text-[11px] uppercase tracking-[0.3em] kazo-text-burgundy mb-4">REFER &amp; EARN</div>
      <h1 className="editorial-headline text-5xl lg:text-7xl mb-12">Share the joy.<br /><em className="font-light">Earn together.</em></h1>
      <div className="grid md:grid-cols-2 gap-12 items-start">
        <div className="bg-white border border-black/10 p-10">
          <div className="text-xs uppercase tracking-widest text-neutral-500 mb-2">YOU EARN</div><div className="font-display text-6xl kazo-text-burgundy mb-2" data-testid="referrer-points">{referrer} pts</div>
          <p className="text-sm text-neutral-600 mb-8">When an eligible referral completes the qualifying action.</p>
          <div className="text-xs uppercase tracking-widest text-neutral-500 mb-2">YOUR FRIEND GETS</div><div className="font-display text-6xl kazo-text-burgundy" data-testid="referee-points">{referee} pts</div>
        </div>
        <div className="text-neutral-700"><h3 className="font-display text-3xl mb-4">How to share</h3><ol className="space-y-2 list-decimal pl-5"><li>Access your {BRAND.loyaltyProgramName} membership.</li><li>Copy your unique referral code.</li><li>Share it with someone special.</li><li>Configured rewards are credited after eligibility is confirmed.</li></ol></div>
      </div>
    </div>
  );
}